export default __webpack_public_path__ + "static/Retul-lab-2-65faa8100b78eaa84b2881a493c6df3b.jpg";